// extracted by css-extract-rspack-plugin
export default {"LabelTooltip":"Label-module__LabelTooltip__M30br"};